import { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { DialogDelete } from '../'
import { TableRow, TableCell } from 'components/Table'
import { MenuButton, Permitted } from 'components'

import constants from 'constants/index'
import helpers from 'helpers'

import { routes } from 'Routes'

const SalesRow = ({ sale, refresh }) => {
  const [dialogDelete, setDialogDelete] = useState(false)
  const history = useHistory()

  const handleEdit = () =>
    history.push(reverse(routes.sellers.edit, { sellerId: sale?.id }))

  const handleShow = () =>
    history.push(reverse(routes.sellers.show, { sellerId: sale?.id }))

  const handleDialogDelete = () => setDialogDelete(true)

  return (
    <>
      <TableRow key={sale?.id}>
        <TableCell>{sale?.id}</TableCell>
        <TableCell>{sale?.name}</TableCell>
        <TableCell>{constants.seller.TRANSLATED_KINDS[sale?.kind]}</TableCell>
        <TableCell>
          {helpers.formatters.document.identify(sale?.document) || '-'}
        </TableCell>
        <TableCell>{sale?.higherLevel || '-'}</TableCell>
        <TableCell>{sale?.quantityContractActive || '-'}</TableCell>
        <TableCell>
          {helpers.formatters.currencyInput(sale?.mmr) || '-'}
        </TableCell>
        <TableCell>{sale?.status ? 'Sim' : 'Não'}</TableCell>
        <TableCell disableTooltip>
          <Permitted
            someTags={[
              constants.permissions.SELLERS.CREATE,
              constants.permissions.SELLERS.SHOW,
              constants.permissions.SELLERS.DESTROY,
            ]}
          >
            <MenuButton>
              <Permitted tag={constants.permissions.SELLERS.CREATE}>
                <Button onClick={handleEdit} fullWidth size="small">
                  Editar
                </Button>
              </Permitted>
              <Permitted tag={constants.permissions.SELLERS.SHOW}>
                <Button onClick={handleShow} fullWidth size="small">
                  Visualizar
                </Button>
              </Permitted>
              <Permitted tag={constants.permissions.SELLERS.DESTROY}>
                <Button onClick={handleDialogDelete} fullWidth size="small">
                  Excluir
                </Button>
              </Permitted>
            </MenuButton>
          </Permitted>
        </TableCell>
      </TableRow>
      {dialogDelete && (
        <DialogDelete
          open={dialogDelete}
          setOpen={setDialogDelete}
          sellerId={sale?.id}
          refresh={refresh}
        />
      )}
    </>
  )
}

SalesRow.propTypes = {
  sale: PropTypes.object,
}

export default SalesRow
